export default __webpack_public_path__ + "static/media/image.apptimus-tech-pvt-ltd-1.ba63720a.png";